export default __webpack_public_path__ + "static/media/runscope.1c7528d9.svg";